import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { PropertyTypeEnum } from '@app/enums/property-type.enum';

export class FillingScore2700 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(
            mortgage.repaymentDay &&
            mortgage._contacts[0] &&
            mortgage._contacts[0].declarations &&
            mortgage._contacts[0].declarations.agreesHandlingPersonalData &&
            mortgage._properties.every((p) => {
                if (!p.address.city || !p.address.zipCode) {
                    return false;
                }
                const propType: PropertyTypeEnum = PropertyTypeEnum[p.type];
                if (
                    [
                        PropertyTypeEnum.flatPrivate,
                        PropertyTypeEnum.flatCooperative,
                        PropertyTypeEnum.familyHouse,
                        PropertyTypeEnum.apartmentBuilding,
                    ].includes(propType) &&
                    (!p.address.street || (!p.isDeveloperProject && !p.address.houseNumber))
                ) {
                    return false;
                }
                if (PropertyTypeEnum.land === propType && (!p.address.cadastralTerritory || !p.address.parcelNumber)) {
                    return false;
                }
                if (
                    [PropertyTypeEnum.flatPrivate, PropertyTypeEnum.flatCooperative].includes(propType) &&
                    !p.isDeveloperProject &&
                    !p.address.unitNumber
                ) {
                    return false;
                }
                if ([PropertyTypeEnum.flatPrivate, PropertyTypeEnum.familyHouse].includes(propType)) {
                    if (p.isDeveloperProject === undefined) {
                        return false;
                    }
                    if (p.isDeveloperProject && !p.developerProject) {
                        return false;
                    }
                }
                return true;
            })
        );
    }
}
